import api from "../axios"
import { ENDPOINT_DEV } from '../configs';

export const getActivationHistoryAPI = async (orgId: string, search: string) => {
  return await api.get(ENDPOINT_DEV + `booking/activation/history?org_id=${orgId}&search=${search}`).then((res) => {
    return res;
  });
};
